import { useContext, useMemo, useSyncExternalStore } from 'react';
import { AuthContext } from './AuthContext';
import { authStore } from './authStore';

export function useAuth() {
  const contextStore = useContext(AuthContext) || authStore;
  const snapshot = useSyncExternalStore(contextStore.subscribe, contextStore.getSnapshot);

  return useMemo(() => {
    return {
      ...snapshot,
      isBooting: snapshot.status === 'booting',
      isAuthenticated: snapshot.status === 'authenticated',
      isUnauthenticated: snapshot.status === 'unauthenticated',
      actions: contextStore,
    };
  }, [contextStore, snapshot]);
}
